import React from "react";
import { Helmet } from "react-helmet";
import { ROUTES } from "../../lib/constants";
import { Image } from "../../components/Image/Image";
import { Button } from "../../components/Button/Button";
import styles from "./Streaming.module.scss";
import fireStickHD from "../../images/streaming-fire-stick-HD.jpg";
import fireStick4K from "../../images/streaming-fire-stick-4K.jpg";
import rokuExpress4K from "../../images/streaming-roku-express-4K.jpg";
import rokuExpressHD from "../../images/streaming-roku-express-HD.jpg";
import myBundleScreenshot from "../../images/streaming-mybundle-screenshot.png";

const products = [
  { src: fireStickHD, alt: "Amazon Fire TV Stick HD", href: "https://amzn.to/4tdCMIF" },
  { src: fireStick4K, alt: "Amazon Fire TV Stick 4K Max", href: "https://amzn.to/48S4IsV" },
  { src: rokuExpress4K, alt: "Roku Express 4K", href: "https://amzn.to/4ttiFoL" },
  { src: rokuExpressHD, alt: "Roku Express HD", href: "https://amzn.to/4wdmgK1" },
];

export const Streaming = (): React.JSX.Element => {
  return (
    <>
      <Helmet>
        <title>{ROUTES.streaming.title}</title>
        <meta
          name="description"
          content="Bundle your live streaming internet TV service with Cityside Fiber— the best & most reliable way to stream on your new internet connection."
        />
        <meta property="og:title" content={`${ROUTES.streaming.title}`} />
        <meta
          property="og:description"
          content="Bundle your live streaming internet TV service with Cityside Fiber— the best & most reliable way to stream on your new internet connection."
        />
        <meta
          property="og:url"
          content="https://www.citysidefiber.com/streaming"
        />
      </Helmet>

      <section className={styles.hero}>
        <div className="grid-12 container">
          <h1>Streaming made easy!</h1>
          <p>
            Click on the buttons below to purchase Amazon Fire TV Sticks or Roku
            devices. You choose what to watch!
          </p>
          <div className={styles.products}>
            {products.map((product) => (
              <div key={product.alt} className={styles.card}>
                <Image
                  sources={[{ src: product.src, breakpoint: "default" }]}
                  alt={product.alt}
                />
                <Button className="bg-color--daylight-blue" href={product.href} size="md" target="_blank">
                  Buy Now
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.myBundle}>
        <div className="grid-12 container">
          <p className={styles.myBundleLabel}>
            Looking for a <br className={styles.mobileBreak} />Streaming Service?
          </p>
          <h2>Check out <br className={styles.mobileBreak} />MyBundle!</h2>
          <a
            href="https://mybundle.tv/citysidefiber/streamtv"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.myBundleLink}
          >
            <Image
              sources={[{ src: myBundleScreenshot, breakpoint: "default" }]}
              alt="MyBundle streaming service discovery platform"
            />
          </a>
        </div>
      </section>
    </>
  );
};
